'use client';

import { FC } from 'react';
import { useCompetitionContext } from "../../providers/CompetitionContext";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { Calendar } from "../../components/calendar";

import moment from 'moment';
import 'moment/locale/fr';
moment.locale('fr');

interface Race {
  id: number;
  feedUrl: string;
  date: string;
  type: string;
}

const CalendarPage: FC = () => {
  const { competitionData, brand } = useCompetitionContext();

  // Example label function
  const getTypeLabel = (type: string) => {
    switch (type) {
      case "wt":
        return "WT"
      case "nwt":
        return "NWT"
      case "monument":
        return "MON"
      default:
        return type.toUpperCase()
    }
  }

  return (
    <>
      <div className="bg-white p-4 pb-72">
      <h1 className="text-xl font-bold my-4">Kalender</h1>
            <Calendar/>
            <p className='py-4'>
          Tijdens het voorjaar is er volop actie en kun je voor vier étappeen in de
          prijzen vallen. En uiteraard ook met winst in het eindklassement. Het loont
          dus zeker de moeite om ook tijdens het voorjaar nog gratis in te stappen.
          Schrijf je dus zeker in, en misschien worden jouw wieleravonturen wel naar
          een hoger niveau getild met de producten van 12GO Biking!
        </p>
        <p className=""><a href="/prizes" className={`text-${brand}-header`}>Bekijk de prijzen</a></p>
      </div>
    </>
  );
};

export default CalendarPage;
